import { useMutation } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';

type RetireLegacyVagAccountsParams = {
  vagDssAccountId: number;
  createTask: boolean;
};

async function retireLegacyVagAccounts(axios: AxiosInstance, { vagDssAccountId, createTask }: RetireLegacyVagAccountsParams): Promise<object> {
  const { data } = await axios.post(`${config.apiBaseUrl}/op/v2/account/${vagDssAccountId}/retire-legacy-vag-accounts`, { create_task: createTask });
  return data;
}

export default function useRetireLegacyVagAccountsMutation() {
  const axios = useAxios();

  return useMutation({
    mutationKey: ['RetireLegacyVagAccounts'],
    mutationFn: (params: RetireLegacyVagAccountsParams) => retireLegacyVagAccounts(axios, params),
  });
}
